
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


export default {
  directives: {
    TransferDom
  },
  data() {
    return {
      isShow: false,
      itemInfo: {}
    }
  },
  props: ['list'],
  methods: {
    showLogo(obj) {
      this.itemInfo = obj
      this.isShow = true
    },
    tinyPic(url) {
      return `${url}?imageView2/1/w/300/h/300`
    }
  },
  components: {
    Popup
  }
}



// WEBPACK FOOTER //
// ./src/components/Scroller/Scroller.vue